module.exports = __webpack_public_path__ + "static/media/reservation_color.889fb587.svg";